/**
 * What the Amplitude autocapture records as `[Amplitude] Element Clicked`
 * (TASK-1173): clicks on the site's real controls, nothing else. The event
 * carries the click position and the viewport size, which is all a click
 * heatmap needs, so the heatmaps are built from our own export instead of
 * Amplitude's paid Heatmaps.
 *
 * Form fields are never tracked, in either action: the SDK's default would
 * record `[Amplitude] Element Changed` on the station search box, and its
 * element text is what the visitor typed. The map canvas is not a control —
 * a station tap is `station_tapped` already.
 */
export const ELEMENT_CLICK_SELECTORS = [
  'a',
  'button',
  '[role="button"]',
  'label',
  '[data-amp-default-track]',
] as const

const FORM_FIELD_TAGS = new Set(['input', 'select', 'textarea'])

/**
 * The SDK's `shouldTrackEventResolver(actionType, element)` — when set, it
 * replaces the SDK's own decision entirely (Browser SDK 2.11.1).
 */
export function shouldTrackElementClick(actionType: string, element: Element): boolean {
  if (actionType !== 'click') return false
  if (FORM_FIELD_TAGS.has(element.tagName.toLowerCase())) return false
  if (element.closest('[contenteditable=""], [contenteditable="true"]')) return false
  return ELEMENT_CLICK_SELECTORS.some((selector) => element.matches(selector))
}
